import { generateID } from './PanelTemplatesTheme/helpers';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import { Panel } from '../../models/Panel/Panel';

export var TemplateEditorial6: Panel = {
    id: 'editorial-6',
    name: 'Image 3-up',
    description: '',
    tags: ['Editorial', 'text', 'image', 'landscape', 'portrait', 'interstitial'],
    widget: {
        id: generateID(),
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_custom',
        label: {
            titleText: 'Panel',
            enabled: false,
            size: WIDGET_LABEL_SIZE.primary,
        },
        children: [
            {
                type: 'customContentImage',
                id: '1',
                name: 'Image',
                position: {
                    grid: {
                        enabled: true,
                        columns: {
                            start: 0,
                            end: 6,
                        },
                        rows: {
                            start: 0,
                            end: 6,
                        },
                    },
                    portrait: {
                        grid: {
                            enabled: true,
                            columns: {
                                start: 0,
                                end: 12,
                            },
                            rows: {
                                start: 0,
                                end: 4,
                            },
                        },
                    },
                },
                label: {
                    titleText: 'Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentImageUrl: '/public/assets/MomentofHappiness2.jpg',
                    contentImageFit: 'cover',
                    horizontalAlign: 'right',
                },
            },
            {
                type: 'customContentImage',
                id: '2',
                name: 'Image',
                position: {
                    grid: {
                        enabled: true,
                        columns: {
                            start: 0,
                            end: 12,
                        },
                        rows: {
                            start: 0,
                            end: 3,
                        },
                    },
                    portrait: {
                        grid: {
                            enabled: true,
                            columns: {
                                start: 0,
                                end: 6,
                            },
                            rows: {
                                start: 4,
                                end: 6,
                            },
                        },
                    },
                },
                label: {
                    titleText: 'Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentImageUrl: '/public/assets/MomentofFriendship1.jpg',
                    contentImageFit: 'cover',
                    verticalAlign: 'bottom',
                },
            },
            {
                type: 'customContentImage',
                id: '3',
                name: 'Image',
                position: {
                    grid: {
                        enabled: true,
                        columns: {
                            start: 6,
                            end: 12,
                        },
                        rows: {
                            start: 3,
                            end: 6,
                        },
                    },
                    portrait: {
                        grid: {
                            enabled: true,
                            columns: {
                                start: 6,
                                end: 12,
                            },
                            rows: {
                                start: 4,
                                end: 6,
                            },
                        },
                    },
                },
                label: {
                    titleText: 'Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentImageUrl: '/public/assets/MomentofTeamwork2.jpg',
                    contentImageFit: 'cover',
                    verticalAlign: 'bottom',
                },
            },
        ],
    },
};
